module.exports = __webpack_public_path__ + "img/9788989571940.5beed66b.jpg";